import React, { Component } from 'react';
import Button, { Link } from '~/UI/Button';
import buttonPrimaryWideStyles from '~/UI/Button/primary-wide.less';
import FormFieldError from '~/UI/FormFieldError/FormFieldError';
import Heading from '~/UI/Heading/Heading';
import Input from '~/UI/Input/Input';
import wideInputStyles from '~/UI/Input/wide.less';

import styles from './styles.less';

export interface LoginResult {
	emailError: string | null;
	passwordError: string | null;
}

interface Props {
	isFetching: boolean;
	onLogin: (email: string, password: string) => Promise<LoginResult>;
}

interface State {
	email: string;
	password: string;
	emailError: string | null;
	passwordError: string | null;
}

export default class LoginPage extends Component<Props, State> {
	state = { email: '', password: '', emailError: null, passwordError: null };

	formSubmitted = async (event: React.FormEvent<HTMLFormElement>) => {
		const {
			state: { email, password },
			props: { onLogin },
		} = this;

		event.preventDefault();
		this.setState({ emailError: null, passwordError: null });

		const result = await onLogin(email.trim(), password.trim());
		if (result.emailError !== null || result.passwordError !== null) {
			this.setState(result);
		}
	};

	render() {
		const {
			props: { isFetching },
			state: { email, password, emailError, passwordError },
		} = this;

		return (
			<section className={styles.section}>
				<div className={styles.in}>
					<form data-testid='login-form' onSubmit={this.formSubmitted}>
						<div className={styles.form}>
							<Heading>Login</Heading>

							<Input
								autoComplete='on'
								disabled={isFetching}
								isInvalid={emailError !== null}
								name='email'
								placeholder='Email'
								styles={wideInputStyles}
								onChange={(event) => this.setState({ email: event.currentTarget.value })}
							/>
							{emailError !== null ? <FormFieldError>{emailError}</FormFieldError> : null}

							<Input
								autoComplete='on'
								disabled={isFetching}
								isInvalid={passwordError !== null}
								name='password'
								placeholder='Password'
								styles={wideInputStyles}
								type='password'
								onChange={(event) => this.setState({ password: event.currentTarget.value })}
							/>
							{passwordError !== null ? <FormFieldError>{passwordError}</FormFieldError> : null}

							<Button disabled={email === '' || password === '' || isFetching} styles={buttonPrimaryWideStyles}>
								Login
							</Button>

							<Link to='/reset-password'>Forgot password?</Link>
						</div>
					</form>
				</div>
			</section>
		);
	}
}
